import BarChart from "./protoCharts/BarChart";
import styles from "./../../styles/charts/chartStyle.module.css";
import { useFundsBudgetAnalyticsData } from "../../lib/hooks";
import { Box, Modal, Paper, Typography } from "@mui/material";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "./twitter/TwitterWordCloud";
import { useState } from "react";
import { desc } from "../../lib/chartDescription";
import CloseIcon from "@mui/icons-material/Close";

export default function TotalBudgetPerFund(props: any) {
  const { loading, fundsBudgetAnalyticsData, error } =
    useFundsBudgetAnalyticsData();

  let chartData: any[] = [];
  let categories: any[] = [];

  !loading &&
    error === null &&
    fundsBudgetAnalyticsData.forEach((item) => {
      chartData.push({ x: item.fund_name, y: item.fund_budget });
      categories.push(item.fund_name);
    });

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  function content(showMaxButton: boolean) {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter">
          <Typography className={styles.chartHeader}>
            {props.chartTitle}
          </Typography>
        </div>
        <div style={{ width: "100%" }}>
          <BarChart
            loading={loading}
            chartData={chartData}
            xLabel={props.xLabel}
            yLabel={props.yLabel}
            title={props.chartTitle}
            categories={categories}
            isDollar
          />
          {getChartBottomIcons(showMaxButton, setOpen)}
          {getChartInfoIcons(desc["fund"]["budget"])}
        </div>
      </Paper>
    );
  }
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <>
          <Box className={styles.fullScreenChart}>{content(false)}</Box>
        </>
      </Modal>
      {content(true)}
    </>
  );
}
